// Blurred background component for document and collection pages.

import React from 'react';
import { ASSETS } from '@airhead-games/shared/configs';

interface BackgroundBlurredProps {
  imageAsset: keyof typeof ASSETS;
  className?: string;
  overlayClassName?: string;
}

const BackgroundBlurred: React.FC<BackgroundBlurredProps> = ({
  imageAsset,
  className = 'document-hero-blurred-bg absolute inset-0 bg-cover bg-center opacity-45 blur-2xl',
  overlayClassName = 'absolute inset-0 bg-background/55',
}) => (
  <>
    <div
      className={className}
      style={{ backgroundImage: `url(${ASSETS[imageAsset]})` }}
      aria-hidden="true"
    />
    <div className={overlayClassName} aria-hidden="true" />
  </>
);

export default BackgroundBlurred;
